import { api } from './index';

const BASE_PATH = '/api/internal/shift_imports';

export type ShiftImportStatus =
  | 'pending'
  | 'analyzing'
  | 'previewed'
  | 'committing'
  | 'completed'
  | 'completed_with_warnings'
  | 'failed';

export type ShiftImportRowError = {
  row: number | null;
  // Group-level errors: the 1-indexed spreadsheet rows the failed group came from.
  rows?: number[] | null;
  patientDni: string | null;
  caregiverDni: string | null;
  message: string;
};

export type ShiftImportPreview = {
  wouldCreate?: number;
  wouldDuplicate?: number;
  wouldFail?: number;
};

export type ShiftImport = {
  id: number;
  status: ShiftImportStatus;
  month: number;
  year: number;
  errorMessage: string | null;
  createdCount: number;
  duplicateCount: number;
  missingPatients: string[];
  missingCaregivers: string[];
  rowErrors: ShiftImportRowError[];
  preview: ShiftImportPreview;
  // Serialized from ShiftImport#warnings? — the same flag the commit policy
  // gates on, so the UI can never drift from the backend rule.
  warnings: boolean;
  createdAt: string;
};

export const shiftImportsApi = {
  show(id: number): Promise<ShiftImport> {
    return api({
      method: 'get',
      url: `${BASE_PATH}/${id}`,
    }).then(response => response.data.shiftImport);
  },

  create(formData: FormData): Promise<ShiftImport> {
    return api({
      method: 'post',
      url: BASE_PATH,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData,
    }).then(response => response.data.shiftImport);
  },

  commit(id: number): Promise<ShiftImport> {
    return api({
      method: 'post',
      url: `${BASE_PATH}/${id}/commit`,
    }).then(response => response.data.shiftImport);
  },
};
